import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataPatientDiagnosis extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name: CurrentLang().edit_patient_diagnosis_code_label, value: StringUtils.formatStringOrNoData(data.CodeTypeIcd10, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_primary_diagnosis_label, value:  StringUtils.formatStringOrNoData(data.PrimaryDiagnosis, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_secondary_diagnosis_label, value:  StringUtils.formatStringOrNoData(data.SecondaryDiagnosis, CurrentLang().no_data) }
        ]
        return tableData;
    }
}

export default MagstimTableDataPatientDiagnosis;
